import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import landingApiService from '../../../services/landingApi';
import { isStaticFullLandingSlug } from '../../../data/staticLandingSlugs';
import ClientProposalLayout from './ClientProposalLayout';
import ProgramProposalLayout from './ProgramProposalLayout';

const LandingMediaKitProposal = ({
  themeMode = 'light',
  staticOnly = false,
  forcedSlug = '',
}) => {
  const { slug: routeSlug } = useParams();
  const slug = forcedSlug || routeSlug;
  const history = useHistory();
  const [proposal, setProposal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setError('Slug no especificado');
      return;
    }
    let cancelled = false;
    const fetchProposal = async () => {
      try {
        setLoading(true);
        setError(null);
        if (staticOnly) {
          const data = await landingApiService.getProposalBySlugStatic(slug);
          if (!cancelled) {
            if (data) {
              setProposal(data);
            } else if (!isStaticFullLandingSlug(slug)) {
              history.replace(`/show/${slug}`);
            } else {
              setError(`Propuesta no encontrada para "/${slug}".`);
            }
            setLoading(false);
          }
          return;
        }
        const data = await landingApiService.getProposalBySlug(slug);
        if (!cancelled) setProposal(data);
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading proposal:', err);
          const hint = slug === 'doctorcondminio' ? ' ¿Quisiste decir /doctorcondominio?' : '';
          setError(`Propuesta no encontrada para "/${slug}".${hint}`);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchProposal();
    return () => { cancelled = true; };
  }, [slug, staticOnly, history]);

  useEffect(() => {
    if (!proposal) return;
    if (proposal.metaTitle) document.title = proposal.metaTitle;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && proposal.metaDescription) desc.setAttribute('content', proposal.metaDescription);
    return () => {
      document.title = 'TNO Media Kit | Anuncia con Nosotros';
    };
  }, [proposal]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Typography color="textSecondary">Cargando propuesta...</Typography>
      </Box>
    );
  }

  if (error || !proposal) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Typography color="error">{error || 'Propuesta no encontrada'}</Typography>
      </Box>
    );
  }

  const content = proposal.content || {};

  return (
    <Box>
      {proposal.type === 'client' && (
        <ClientProposalLayout content={content} themeMode={themeMode} proposalName={proposal.name} />
      )}
      {proposal.type === 'program' && (
        <ProgramProposalLayout content={content} themeMode={themeMode} proposalName={proposal.name} />
      )}
    </Box>
  );
};

LandingMediaKitProposal.propTypes = {
  themeMode: PropTypes.string,
  staticOnly: PropTypes.bool,
  forcedSlug: PropTypes.string,
};

export default LandingMediaKitProposal;
